"use strict";

import "./MapButton";
import React from "react";

import listenResize from "vwa/utils/listenResize";

import dispatcher from "./../../dispatcher";
import autoZoomStore from "./../../store/autoZoom";
import mapStateStore from "./../../store/mapState";
import mapTooltipStore from "./../../store/mapTooltip";

import lang from "vwa/lang";
import BubbleController from "./BubbleController";
import POIController from "./POIController";
import VehicleActivityController from "./VehicleActivityController";
import VehicleHeatmapController from "./VehicleHeatmapController";
import VehiclePOICrossingsController from "./VehiclePOICrossingsController";
import TooltipController from "./TooltipController";

import ContextMenu from "./ContextMenu";

const DEFAULT_CENTER = {lat: 47, lng: 19};
const DEFAULT_ZOOM = 7;

export default class Map extends React.Component {

	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			traffic: false
		};
	}
	
	render() {
		return <div ref="container" className={this.props.cat ? "Cat" : ""}/>;
	}
	
	componentDidMount() {
		let prevW = 0;
		let prevH = 0;
		
		listenResize(this.refs.container, (w,h) => {
			this.resize();
			if(prevW == 0 && w > 0 && prevH == 0 && h > 0){
				prevH = h;
				prevW = w;
				this.bubbleController.refreshAllBubbles();
			}
		});
	}
	
	shouldComponentUpdate(nextProps, nextState) {
		if (nextState.traffic !== this.state.traffic)
			return false;
		return true;
	}
	
	componentDidUpdate() {
		if (this.props.ready)
			this.createMap();
	}

	createMap() {
		if (this.gmap) return;
		this.gmap = new google.maps.Map(this.refs.container, this.getOptions());
		window.gmap = this.gmap;
		this.trafficLayer = new google.maps.TrafficLayer();
		this.createControllers();
		this.createAutoZoomButton();
		this.createTrafficButton();
		this.listendBoundsChange = true;
		this.setListeners();
		this.setStoreListeners();
	}
	
	getOptions() {
		return {
			center: DEFAULT_CENTER,
			zoom: DEFAULT_ZOOM,
			streetViewControl: false,
			panControl: false,
			zoomControlOptions: {style: google.maps.ZoomControlStyle.SMALL},
			mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'usroadatlas']
		};
	}
	
	setListeners() {
		google.maps.event.addListener(this.gmap, 'bounds_changed', _ => {
			if (this.listendBoundsChange)
				this.handleBoundsChanged();
		});
		google.maps.event.addListener(this.gmap, 'rightclick', evt => this.createContextMenu(evt.latLng));
	}
	
	setStoreListeners() {
		mapStateStore.on("change", descriptor => {
			this.listendBoundsChange = false;
			const currentCenter = this.gmap.getCenter().toJSON();
			if ("center" in descriptor) {
				if (descriptor.center.lat != currentCenter.lat || descriptor.lng != currentCenter.lng)
					this.gmap.setCenter(descriptor.center);
			}
			if ("zoom" in descriptor) {
				if (descriptor.zoom != this.gmap.getZoom())
					this.gmap.setZoom(descriptor.zoom);
			}
			if ("bounds" in descriptor)
				this.gmap.fitBounds(descriptor.bounds);
			setTimeout(() => this.listendBoundsChange = true);
		});
	}
	
	handleBoundsChanged() {
		if (!this.gmap) return;
		dispatcher.dispatch('setMap', {
			center:	this.gmap.getCenter().toJSON(),
			zoom:	this.gmap.getZoom()
		});
	}

	createControllers() {
		this.bubbleController = new BubbleController(this.gmap);
		window.bubbleController = this.bubbleController;
		this.poiController = new POIController(this.gmap);
		window.poiController = this.poiController;
		this.vehicleActivityController = new VehicleActivityController(this.gmap);
		window.vehicleActivityController = this.vehicleActivityController;
		this.vehicleHeatmapController = new VehicleHeatmapController(this.gmap);
		window.vehicleHeatmapController = this.vehicleHeatmapController;
		this.vehiclePOICrossingsController = new VehiclePOICrossingsController(this.gmap);
		window.vehiclePOICrossingsController = this.vehiclePOICrossingsController;
		this.tooltipController = new TooltipController(this.gmap);
		window.tooltipController = this.tooltipController;
	}

	createAutoZoomButton() {
		const autoZoomButton = document.createElement("div");
		autoZoomButton.className = "MapButton";
		autoZoomButton.title = lang.AUTOZOOM;
		const icon = document.createElement("i");
		autoZoomButton.appendChild(icon);
		icon.className = `mdi mdi-eye${autoZoomStore.get() ? "" : "-off"}`;

		this.gmap.controls[google.maps.ControlPosition.RIGHT_TOP].push(autoZoomButton);

		autoZoomButton.onclick = () => dispatcher.dispatch('toggleAutoZoom');
		autoZoomStore.on('change', value => icon.className = `mdi mdi-eye${value ? "" : "-off"}`);
	}
	
	toggleTraffic() {
		this.setState({
			traffic: !this.state.traffic
		}, () => {
			this.trafficLayer.setMap(this.state.traffic ? this.gmap : null)
			this.updateTrafficButton();
		});
	}

	createTrafficButton() {
		this.refs.trafficButton = document.createElement("div");
		this.refs.trafficButton.className = "MapButton";
		this.refs.trafficButton.title = lang.TRAFFIC;
		const icon = document.createElement("i");
		this.refs.trafficButton.appendChild(icon);
		icon.className = "mdi mdi-traffic-light";

		this.gmap.controls[google.maps.ControlPosition.LEFT_TOP].push(this.refs.trafficButton);
		
		this.refs.trafficButton.onclick = () => this.toggleTraffic();
		
		this.updateTrafficButton();
	}
	
	createContextMenu(position) {
		const contextMenu = new ContextMenu({
			map:		this.gmap,
			position:	position,
			items:		[
							{
								label:		lang.CREATE_POI,
								onClick:	() => this.props.onCreatePOI(position)
							}
						]
		});
	}

	updateTrafficButton() {
		if (this.state.traffic)
			this.refs.trafficButton.classList.remove("Inactive");
		else
			this.refs.trafficButton.classList.add("Inactive");
	}

	resize() {
		if (this.gmap)
			google.maps.event.trigger(this.gmap, "resize");
	}
}

Map.propTypes = {
	ready:			React.PropTypes.bool,
	onCreatePOI:	React.PropTypes.func,
};

Map.defaultProps = {
	ready:			false,
	onCreatePOI:	location => {}
};


// WEBPACK FOOTER //
// ./src/view/Map/Map.jsx